import React from "react";
import { Circular } from "./Circular/Circular";
import { AxiosInterceptor } from "../axios/AxiosInterceptor";

/**
 * Function that renders the main app.
 * @returns the JSX representing the main app.
 */
export const App = (): React.JSX.Element => {
    return (
        <AxiosInterceptor>
            <Circular />
        </AxiosInterceptor>
    );
};
